export const HELP_LINK = 'https://calendly.com/d/3t8-mr6-ts4/proxima-intro';
export const HELLO_EMAIL = 'hello@proxima.ai';
